// /home/dsingh/qchat/qchat_fe/src/Component/SideData/Sidebar/itemList.js

import React from "react";
import {
  RiDashboard2Line,
  RiGroupLine,
  RiShieldUserLine,
  RiNotification3Line,
  RiSettings3Line,
  RiRobot2Line,
} from "react-icons/ri";
import {
  LuFileKey2,
  LuUserCircle2,
  LuPhoneCall,
  LuCombine,
  LuSparkles,
  LuAtom,
  LuGlobe,
  LuWebhook,
  LuPlug,
  LuBot,
} from "react-icons/lu";
import { GrChat } from "react-icons/gr";
import FailedAIMsgs from "../Overview/FailedAIMsgs";
import {
  MdOutlineIntegrationInstructions,
  MdDeveloperBoard,
  MdOutlineWidgets,
} from "react-icons/md";
import { filterMenuGroupsByFeatureFlags } from "../../../config/featureFlags";

// ============================================================
// ALL ICON COMPONENTS - DIV-BASED ICONS
// ============================================================

const GeneralSettingIc = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuFileKey2 size={22} />
  </div>
);

const ExtensionsIcon = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuAtom size={22} />
  </div>
);

const AIBotIcon = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuBot size={22} />
  </div>
);

const GlobalSettIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuGlobe size={22} />
  </div>
);

const AllChatIC = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <GrChat size={22} />
  </div>
);

const QnaIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuPhoneCall size={22} />
  </div>
);

const LiveChatIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuPhoneCall size={22} />
  </div>
);

const DomainIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuGlobe size={22} />
  </div>
);

const CredentialIcon = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuFileKey2 size={22} />
  </div>
);

const IntegrationIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuCombine size={22} />
  </div>
);

const InviteSupportIocn = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <RiShieldUserLine size={22} />
  </div>
);

const ThemeSettingsIcon = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <RiSettings3Line size={22} />
  </div>
);

const AiAgentWorkFlow = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuBot size={22} />
  </div>
);

const LeadGenWorkFlow = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuUserCircle2 size={22} />
  </div>
);

const APIConfig = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuCombine size={22} />
  </div>
);

const APIChainIc = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuCombine size={22} />
  </div>
);

const ConnectionsIcon = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <LuPlug size={22} />
  </div>
);

const ManagerResSettIc = () => (
  <div style={{ width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
    <RiNotification3Line size={22} />
  </div>
);

// ============================================================
// LEGACY EXPORTS (Keep for backward compatibility)
// ============================================================

export const itemList = [
  {
    id: 1,
    text: "Credentials",
    icon: <CredentialIcon />,
    path: "/credentials",
    permitted_to: ["MANAGER", "DEVELOPER"],
  },
];

export const moderate = [
  {
    id: 2,
    text: "All Chats",
    icon: <AllChatIC />,
    permitted_to: ["CUSTOMER_CARE_EXECUTIVE", "MANAGER"],
  },
];

export const appSettings = [
  {
    id: 3,
    text: "General Settings",
    icon: <GeneralSettingIc />,
    permitted_to: ["MANAGER"],
  },
  {
    id: 4,
    text: "Manage Extensions",
    icon: <ExtensionsIcon />,
    permitted_to: ["MANAGER"],
  },
  {
    id: 5,
    text: "LeadGen & FAQ",
    icon: <QnaIocn />,
    permitted_to: ["MANAGER"],
  },
  { id: 6, text: "AI Chat", icon: <AIBotIcon />, permitted_to: ["MANAGER"] },
  {
    id: 6,
    text: "Skill Workflow",
    icon: <AiAgentWorkFlow />,
    permitted_to: ["DEVELOPER"],
  },
  {
    id: 7,
    text: "Leadgen Workflow",
    icon: <LeadGenWorkFlow />,
    permitted_to: ["DEVELOPER"],
  },
  {
    id: 8,
    text: "API Config",
    icon: <APIConfig />,
    permitted_to: ["DEVELOPER"],
  },
  {
    id: 9,
    text: "ChainApis",
    icon: <APIChainIc />,
    permitted_to: ["DEVELOPER"],
  },
  {
    id: 11,
    text: "Live Agent",
    icon: <LiveChatIocn />,
    permitted_to: ["MANAGER"],
  },
  {
    id: 12,
    text: "App Users",
    icon: <RiGroupLine size={22} />,
    permitted_to: ["MANAGER"],
  },
  { id: 13, text: "Branding", icon: <LuSparkles />, permitted_to: ["MANAGER"] },
  {
    id: 14,
    text: "Failed AI Messages",
    icon: <InviteSupportIocn />,
    permitted_to: ["MANAGER"],
  },
  {
    id: 15,
    text: "Theme Settings",
    icon: <ThemeSettingsIcon />,
    permitted_to: ["MANAGER"],
  },
];

export const globleSettings = [
  { id: 6, text: "Global Tenant Settings", icon: <GlobalSettIocn /> },
];

export const shareDeveloper = [
  {
    id: 7,
    text: "Share Integration Steps",
    icon: <IntegrationIocn />,
    permitted_to: ["MANAGER"],
  },
];

export const inviteSuppUser = [
  { id: 8, text: "Invite Support User", icon: <InviteSupportIocn /> },
];

export const whiteLabelDomains = [
  {
    id: 8,
    text: "Whitelabel Domains",
    icon: <DomainIocn />,
    permitted_to: ["MANAGER", "DEVELOPER"],
  },
];

// ============================================================
// BASE MENU GROUPS (Before Feature Filtering)
// ============================================================

const baseMenuGroups = [
  {
    id: "all_chats",
    label: "All Chats",
    icon: <GrChat size={22} />,
    dataTour: "all-chats",
    items: [
      {
        id: "all_chats",
        text: "All Chats",
        icon: <AllChatIC />,
        path: "/all-chats",
        permitted_to: ["CUSTOMER_CARE_EXECUTIVE", "MANAGER"],
      },
    ],
  },
  {
    id: "credentials",
    label: "Credentials",
    icon: <LuFileKey2 size={22} />,
    dataTour: "credentials",
    items: [
      {
        id: "credentials",
        text: "Credentials",
        icon: <CredentialIcon />,
        path: "/credentials",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
    ],
  },
  {
    id: "live_agent",
    label: "Live Agent",
    icon: <LuPhoneCall size={20} />,
    dataTour: "live-agent",
    items: [
      {
        id: "live_agent",
        text: "Live Agent",
        icon: <LiveChatIocn />,
        path: "/live-agent",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "ai_bot",
    label: "AI Chat",
    icon: <RiRobot2Line size={24} />,
    items: [
      {
        id: "ai_agent",
        text: "AI Chat",
        icon: <AIBotIcon />,
        path: "/ai-agent",
        permitted_to: ["MANAGER"],
      },
      {
        id: "failed_ai_messages",
        text: "Failed AI Messages",
        icon: <InviteSupportIocn />,
        path: "/failed-ai-messages",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "lead_management",
    label: "FAQ Chat & Lead Generation",
    icon: <LuUserCircle2 size={24} />,
    items: [
      {
        id: "leadgen_qna",
        text: "LeadGen & FAQ",
        icon: <QnaIocn />,
        path: "/leadgen-qna",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "ui_field_components",
    label: "UI Field Components Library",
    icon: <MdOutlineWidgets size={22} />,
    items: [
      {
        id: "UI Field Components Library",
        text: "UI Field Components Library",
        icon: <MdOutlineWidgets size={22} />,
        path: "/ui-field-components",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "manage_extensions",
    label: "Manage Extensions",
    icon: <LuAtom size={22} />,
    items: [
      {
        id: "extensions",
        text: "Manage Extensions",
        icon: <ExtensionsIcon />,
        path: "/extensions",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "integrations_apis",
    label: "Agent & Servers",
    icon: <MdOutlineIntegrationInstructions size={24} />,
    items: [
      {
        id: "auth_integration",
        text: "Auth Integration",
        icon: <APIConfig />,
        path: "/auth-inegration",
        permitted_to: ["DEVELOPER"],
      },
      {
        id: "api_config",
        text: "API Config",
        icon: <APIConfig />,
        path: "/api-config",
        permitted_to: ["DEVELOPER"],
      },
      {
        id: "chain_apis",
        text: "ChainApis",
        icon: <APIChainIc />,
        path: "/chain-apis",
        permitted_to: ["DEVELOPER"],
      },
      {
        id: "Connections",
        text: "Connections",
        icon: <ConnectionsIcon />,
        path: "/oauth-connections",
        permitted_to: ["DEVELOPER", "MANAGER"],
      },
    ],
  },

  // ============================================================
  // WORKFLOWS — SPLIT INTO TWO GROUPS
  // ============================================================
  //
  // Previously these two workflows lived together in a single group
  // with `id: "workflows"`, which meant enabling AI Agent also
  // enabled Leadgen Workflow (and vice versa). Now each workflow
  // has its own group so the feature-flag filter can gate them
  // independently.
  //
  // • "leadgen_workflows"       → gated by the `leadgen` flag
  // • "ai_agent_workflows"      → gated by the `ai_agent` flag
  //
  // Each group must be registered in FEATURE_TAB_MAP in
  // `config/featureFlags.js` — currently only `ai_agent_workflows`
  // is mapped because `ai_agent` is the only enabled feature.
  // ============================================================

  // --- Leadgen Workflow (hidden while leadgen flag is off) ---
  {
    id: "leadgen_workflows",
    label: "Leadgen Workflows",
    icon: <LuCombine size={20} />,
    items: [
      {
        id: "leadgen_workflow",
        text: "Leadgen Workflow",
        icon: <LeadGenWorkFlow />,
        path: "/leadgen-workflow",
        permitted_to: ["DEVELOPER"],
      },
    ],
  },

  // --- AI Agent Skill Workflow (visible when ai_agent flag is on) ---
  {
    id: "ai_agent_workflows",
    label: "Agent Workflows",
    icon: <LuCombine size={20} />,
    items: [
      {
        id: "ai_agent_workflow",
        text: "Skill Workflow",
        icon: <AiAgentWorkFlow />,
        path: "/ai-agent-workflow",
        permitted_to: ["DEVELOPER"],
      },
    ],
  },

  {
    id: "all_app_users",
    label: "All Users (across apps)",
    icon: <RiGroupLine size={22} />,
    items: [
      {
        id: "app_users",
        text: "App Users",
        icon: <RiGroupLine size={22} />,
        path: "/app-users",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "share_developer",
    label: "Share Developer",
    icon: <MdDeveloperBoard size={25} />,
    items: [
      {
        id: "share_developer",
        text: "Share Integration Steps",
        icon: <IntegrationIocn />,
        path: "/share-developer",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: <RiSettings3Line size={22} />,
    dataTour: "settings",
    items: [
      {
        id: "General Settings",
        text: "General Settings",
        icon: <GeneralSettingIc />,
        path: "/general-settings",
        permitted_to: ["MANAGER"],
      },
      {
        id: "Theme Settings",
        text: "Theme Settings",
        icon: <ThemeSettingsIcon />,
        path: "/theme-settings",
        permitted_to: ["MANAGER"],
      },
      {
        id: "Branding",
        text: "Branding",
        icon: <LuSparkles />,
        path: "/branding",
        permitted_to: ["MANAGER"],
      },
    ],
  },
  {
    id: "global_level_settings",
    label: "Global Level Settings",
    icon: <LuGlobe size={22} />,
    items: [
      {
        id: "global_api_configs",
        text: "Global API Configs",
        icon: <APIConfig />,
        path: "/global-api-configs",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
      {
        id: "global_chains",
        text: "Global API Chains",
        icon: <APIChainIc />,
        path: "/global-chains",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
      {
        id: "global_auth",
        text: "Global Auth Integration",
        icon: <APIConfig />,
        path: "/global-auth",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
      {
        id: "global_connections",
        text: "Global Connections",
        icon: <ConnectionsIcon />,
        path: "/global-connections",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
      {
        id: "global_tenant_settings",
        text: "Global Tenant Settings",
        icon: <GlobalSettIocn />,
        path: "/global-tenant-settings",
        permitted_to: ["MANAGER"],
      },
      {
        id: "invite_support_user",
        text: "Invite Support User",
        icon: <InviteSupportIocn />,
        path: "/invite-support-user",
        permitted_to: ["MANAGER"],
      },
      {
        id: "whitelabel_domains",
        text: "Whitelabel Domains",
        icon: <DomainIocn />,
        path: "/whitelabel-domains",
        permitted_to: ["MANAGER", "DEVELOPER"],
      },
    ],
  },
];

// ============================================================
// EXPORT FILTERED MENU GROUPS
// This is what SidebarMenu.js imports!
// ============================================================
export const menuGroups = filterMenuGroupsByFeatureFlags(baseMenuGroups);